/* @flow */
import React from 'react';
import ExternalAccountResource from 'entities/ExternalAccountResource';
import ExternalAccountResourceActions from 'payments/actions/ExternalAccountResourceActions';
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import Menu from 'components/Menu.jsx';
import MenuButton from 'components/MenuButton.jsx';
import MenuItem from 'components/MenuItem.jsx';
import ModalMenuItem from 'components/ModalMenuItem.jsx';
import ToastActions from 'actions/ToastActions';
import Glyph from 'components/Glyph.jsx';

export default class BankAccountMenuButton extends React.Component {
  static propTypes = {
    bankAccount: React.PropTypes.instanceOf(ExternalAccountResource).isRequired,
  }

  setBankAccountPrimary() {
    ExternalAccountResourceActions
      .makePrimary(this.props.bankAccount)
      .then(
        () => ToastActions.showSuccessToast('Primary bank account updated'),
        () => ToastActions.showDefaultErrorToast(),
      );
  }

  render() {
    const confirmDialog = (
      <ConfirmDialog
        eventScreenName="BankAccountMenuButton"
        title="Are you sure you want to delete this bank account?"
        actionButtonText="Yes"
        cancelButtonText="No"
        onConfirm={() => {
          ExternalAccountResourceActions
          .delete(this.props.bankAccount)
          .then(
            () => ToastActions.showSuccessToast('Bank account removed'),
            () => ToastActions.showDefaultErrorToast(),
          );
        }}
      />
    );

    const menu = (
      <Menu>
        <ModalMenuItem modal={confirmDialog}>
          Remove bank account
        </ModalMenuItem>
        <MenuItem onClick={() => this.setBankAccountPrimary()}>
          Set as primary
        </MenuItem>
      </Menu>
    );

    return (
      <MenuButton
        alignment="right"
        placement="bottom"
        menu={menu}
        size="small"
        level="icon">
        <Glyph name="ellipses" solo />
      </MenuButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/BankAccountsMenuButton.jsx